import { ErrorDialogComponent } from './../error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { StateOption } from './../models/state-option.model';
import { Router } from '@angular/router';
import { Activity } from './../models/activity.model';
import { ProjectDataService } from './../services/project-data.service';
import { Component, OnInit } from '@angular/core';
import { ActivityGroup } from '../models/activity-group.model';

@Component({
  selector: 'app-activity-selection',
  templateUrl: './activity-selection.component.html',
  styleUrls: ['./activity-selection.component.scss'],
  standalone: false,
})
export class ActivitySelectionComponent implements OnInit {
  state: StateOption;
  businessUnit: string;
  fundingProjectID: string;
  activityGroups: ActivityGroup[];
  activityLeftDisplay: Activity[][];
  activityRightDisplay: Activity[][];
  checkboxValues: boolean[][];
  leftDisplayLength: number[];
  stateOptions: StateOption[];
  businessUnitOptions: string[];
  activityGroupsFile: any;

  constructor(
    private projectDataService: ProjectDataService,
    private router: Router,
    private http: HttpClient,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.loadActivityFile();
    this.getProjectData();
  }

  getProjectData() {
    let stateCheck = sessionStorage.getItem('state');
    if (stateCheck) {
      this.state = JSON.parse(stateCheck);
    } else {
      this.state = null;
    }
    this.businessUnit = sessionStorage.getItem('businessUnit');
    this.fundingProjectID = sessionStorage.getItem('fundingProjectID');
    let stateOptionsCheck = sessionStorage.getItem('stateOptions');
    if (stateOptionsCheck) {
      this.stateOptions = JSON.parse(stateOptionsCheck);
    } else {
      this.stateOptions = [];
    }
    let businessUnitOptionsCheck = sessionStorage.getItem('businessUnitOptions');
    if (businessUnitOptionsCheck) {
      this.businessUnitOptions = JSON.parse(businessUnitOptionsCheck);
    } else {
      this.businessUnitOptions = [];
    }
  }

  compareState(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return (
      o1.state == o2.state &&
      o1.major_loc_id == o2.major_loc_id &&
      o1.majorlocation == o2.majorlocation
    );
  }

  getActivities() {
    /*this.activityGroups = [{
      activityCategory: 'Land',
      activities: [{
        activityName: '00000000',
        activityDescription: 'This is 70 characters max'
      }, {
        activityName: '00000000',
        activityDescription: 'This is 70 characters max lorem ipsum cons ectetdour sitip iscing elit'
      }, {
        activityName: '00000000',
        activityDescription: 'This is 70 characters max'
      }, {
        activityName: '00000000',
        activityDescription: 'This is 70 characters max lorem ipsum cons ectetdour sitip iscing elit'
      }, {
        activityName: '00000000',
        activityDescription: 'This is 70 characters max'
      }, {
        activityName: '00000000',
        activityDescription: 'This is 70 characters max lorem ipsum cons ectetdour sitip iscing elit'
      }, {
        activityName: '00000000',
        activityDescription: 'This is 70 characters max'
      }, {
        activityName: '00000000',
        activityDescription: 'This is 70 characters max lorem ipsum cons ectetdour sitip iscing elit'
      }]
    }, {
      activityCategory: 'Pipeline Install',
      activities: [{
        activityName: '00000000',
        activityDescription: 'This is 70 characters max'
      }, {
        activityName: '00000000',
        activityDescription: 'This is 70 characters max lorem ipsum cons ectetdour sitip iscing elit'
      }]
    }];*/
    //this.activityGroups = _.sortBy(this.activityGroups, ['groupName']);
    /*for (let i = 0; i < this.activityGroups.length; i++) {
      this.activityGroups[i].activities = _.sortBy(this.activityGroups[i].activities, ['activityID']);
    }*/
    this.activityLeftDisplay = [];
    this.activityRightDisplay = [];
    this.checkboxValues = [];
    this.leftDisplayLength = [];
    for (let i = 0; i < this.activityGroups.length; i++) {
      this.splitActivitiesIntoTwoRows(i);
    }
    this.loadActivityData();
  }

  splitActivitiesIntoTwoRows(index: number) {
    let rowLength = this.activityGroups[index].activities.length;
    let rowLengthHalf = rowLength / 2;
    let newLeftDisplay: Activity[] = [];
    let newRightDisplay: Activity[] = [];
    let newCheckboxes: boolean[] = [];
    let i;
    for (i = 0; i < rowLengthHalf; i++) {
      newLeftDisplay.push(this.activityGroups[index].activities[i]);
      newCheckboxes.push(false);
    }
    for (let j = i; j < rowLength; j++) {
      newRightDisplay.push(this.activityGroups[index].activities[j]);
      newCheckboxes.push(false);
    }
    this.activityLeftDisplay.push(newLeftDisplay);
    this.activityRightDisplay.push(newRightDisplay);
    this.checkboxValues.push(newCheckboxes);
    this.leftDisplayLength.push(newLeftDisplay.length);
  }

  allChecked(index: number) {
    if (!this.checkboxValues || !this.checkboxValues[index]) {
      return false;
    }
    for (let i = 0; i < this.checkboxValues[index].length; i++) {
      if (!this.checkboxValues[index][i]) {
        return false;
      }
    }
    return true;
  }

  toggleChecked(i: number, j: number) {
    this.checkboxValues[i][j] = !this.checkboxValues[i][j];
  }

  checkAll(index: number) {
    if (!this.allChecked(index)) {
      for (let i = 0; i < this.checkboxValues[index].length; i++) {
        this.checkboxValues[index][i] = true;
      }
    } else {
      for (let i = 0; i < this.checkboxValues[index].length; i++) {
        this.checkboxValues[index][i] = false;
      }
    }
  }

  goToPreviousPage() {
    this.saveActivityData();
    this.router.navigate(['/charging-project-setup']);
  }

  goToSummaryPage() {
    this.saveActivityData();
    this.router.navigate(['/summary']);
  }

  saveActivityData() {
    let selectedActivities = [];
    for (let i = 0; i < this.checkboxValues.length; i++) {
      for (let j = 0; j < this.checkboxValues[i].length; j++) {
        if (this.checkboxValues[i][j]) {
          selectedActivities.push(this.activityGroups[i].activities[j]);
        }
      }
    }
    sessionStorage.setItem('checkboxValues', JSON.stringify(this.checkboxValues));
    sessionStorage.setItem('activities', JSON.stringify(selectedActivities));
  }

  loadActivityData() {
    let checkboxValueCheck = sessionStorage.getItem('checkboxValues');
    if (checkboxValueCheck) {
      this.checkboxValues = JSON.parse(checkboxValueCheck);
    }
  }

  loadActivityFile() {
    this.http.get('assets/gas-activities.json').subscribe(
      (result) => {
        this.activityGroups = result as ActivityGroup[];
        this.getActivities();
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Activity File Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Activity File Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  exitPage() {
    this.router.navigate(['/dashboard']);
  }

  continueDisabled() {
    if (this.anyChecked()) {
      return false;
    } else {
      return true;
    }
  }

  anyChecked() {
    if (!this.checkboxValues) {
      return false;
    }
    for (let i = 0; i < this.checkboxValues.length; i++) {
      for (let j = 0; j < this.checkboxValues[i].length; j++) {
        if (this.checkboxValues[i][j]) {
          return true;
        }
      }
    }
    return false;
  }
}
